@let searches = searches$ | async | notNull;

<pds-module-header title="Buscas & Resultados">
  <pds-panel>
    <peca-monitoring-search (search)="onSearch($event)" />
  </pds-panel>

  @if (searches.data) { @if (hasItems(searches.data.items)) {
  <pds-table>
    <table>
      <thead>
        <tr>
          <th>Data/Hora</th>
          <th>Placa</th>
          <th>CEP</th>
          <th>Busca</th>
          <th>Resultados</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (item of searches.data.items; track $index) {
        <tr>
          <td>
            {{ item.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}
          </td>
          <td>{{ item.args.search.plate }}</td>
          <td>{{ item.args.search.address?.postalCode ?? item.args.search.postalCode ?? '-' }}</td>
          <td>{{ firstOrNull(item.args.search.products)?.description || '-' }}</td>
          <td>
            @if ( hasItems(item.response.products) && hasItems(item.response.products[0].possibilities) ) {
            <span>{{ firstOrNull(item.response.products)?.possibilities?.length }}</span>
            } @else {
            <span pdsChip>sem resultados</span>
            }
          </td>
          <td pdsColActions>
            <button pdsButton="icon" (click)="onClickOpenProductsModal(firstOrNull(item.response.products))" [disabled]="!hasItems(firstOrNull(item.response.products)?.possibilities)">
              <span class="icon">visibility</span>
            </button>
            <button pdsButton="icon" (click)="onClickOpenLogsModal(item)">
              <span class="icon">data_object</span>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </pds-table>
  <pds-pagination [pagination]="pagination$" (paginate)="onPageChange($event)"></pds-pagination>
  } @else {
  <h4>Nenhuma busca encontrada</h4>
  } } @else if (searches.loading) {
  <h4>carregando...</h4>
  } @else if (searches.failure) {
  <h4>Falha ao buscar resultados</h4>
  }
  <pds-modal #products [width]="1024" title="Produtos" (dismiss)="onClickCloseProductsModal()">
    @if (selectedProduct) {
    <h4>{{ selectedProduct.description | uppercase }}</h4>
    <hr />
    <pds-table>
      <table>
        <thead>
          <tr>
            <th>Descrição</th>
            <th>PN</th>
            <th>Marca</th>
            <th>QTD</th>
            <th>Frete</th>
            <th>Preço</th>
            <th>Promessa</th>
            <th>Prazo</th>
          </tr>
        </thead>
        <tbody>
          @for (item of selectedProduct.possibilities; track $index) {
          <tr>
            <td>{{ item.description }}</td>
            <td>{{ item.partNumber }}</td>
            <td>{{ item.brand }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.shippingPrice | currency : 'BRL' }}</td>
            <td>{{ item.productTotalPrice | currency : 'BRL' }}</td>
            <td>{{ item.deadlineHours }}h</td>
            <td>{{ item.expectedDelivery | date : 'dd/MM/yyyy hh:mm' }}</td>
          </tr>
          }
        </tbody>
      </table>
    </pds-table>
    }
  </pds-modal>
  <pds-modal #logs [width]="1024" title="Logs" (dismiss)="onClickCloseLogsModal()">
    <div class="monitoring-logs-viewer">
      <pre>{{ selectedLogs | json }}</pre>
    </div>
  </pds-modal>
</pds-module-header>
